export const AlertsModule = {
  namespaced: true,
  state: {
    alerts: [],
  },
  getters: {
    alertForType: state => {
      return category => state.alerts.filter(alert => alert.category === category)
    },
  },
  actions: {
    addAlert: ({ dispatch }, alert) => {
      // startsWith instead of strict equality checks allows backwards compat for different string types.
      if (alert.category.startsWith('elopement')) {
        dispatch('elopementRisks/incomingElopementAlert', { alert }, { root: true })
      } else if (alert.category.startsWith('object')) {
        dispatch('events/addEvent', alert, { root: true })
      } else if (alert.category.startsWith('face_mask_alert')) {
        dispatch('faceMaskAlerts/incomingFaceMaskAlert', { alert }, { root: true })
      } else {
        console.log(`Received an alert of unknown 'category': '${alert.category}'. Dropping.`)
      }
    },
  },
}
